import { FC } from 'react';
import MembersTimeLine from './MembersTimeLine';
import Subscribe from './Subscribe';
import Nav from './Nav';
import CelebratingUs from './CelebratingUs';
import JoinUs from './JoinUs';
import ReferralNext from './ReferralNext';
import EcoBenefits from './EcoBenefits';
import ActivityPreview from './ActivityPreview';
import BottomTips from './BottomTips';
import FutureBenefits from './JP/FutureBenefits';
import ProductPreview from './JP/ProductPreview';
import Additional from './JP/Additional';
import getLocal from '@/app/utils/getLocal';

const TeaserCompoment: FC = ({}) => {
    const { locale } = getLocal();

    const normalComp = () => (
        <>
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="teaser" />
            <div className="members-day-over"></div>
            <ActivityPreview />
            <div className="members-day-over"></div>
        </>
    );

    const jpComp = () => (
        <>
            <div className="members-day-over"></div>
            <FutureBenefits />
            <div className="members-day-over"></div>
            <ActivityPreview />
            <div className="members-day-over"></div>
            <ProductPreview />
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <Additional />
            <div className="members-day-over"></div>
        </>
    );

    const krComp = () => (
        <>
            <div className="members-day-over"></div>
            <ReferralNext />
            <div className="members-day-over"></div>
            <EcoBenefits cls="teaser" />
            <div className="members-day-over"></div>
            <ActivityPreview />
            <div className="members-day-over"></div>
        </>
    );

    return (
        <div className="page-teaser">
            {locale !== 'jp' && <div className="members-day-over"></div>}
            <MembersTimeLine />
            {locale !== 'jp' && <div className="members-day-over"></div>}
            {locale !== 'jp' && <Subscribe />}
            <div className="members-day-over"></div>
            <Nav />
            <CelebratingUs />
            <div className="members-day-over"></div>
            <JoinUs />
            {locale === 'jp' && jpComp()}
            {locale === 'kr' && krComp()}
            {!['jp', 'kr'].includes(locale) && normalComp()}
            <BottomTips />
        </div>
    );
};

export default TeaserCompoment;
